import {
    Autocomplete,
    Checkbox,
    FormControl,
    TextField,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";

const DropdownSearchSelector = ({
    label,
    options,
    selected,
    setSelected,
    multiple = false,
    error,
    required = false,
}) => {
    // Convert options [id, label, order?] → objects for Autocomplete
    const formattedOptions = options
        .map(([id, label, order = 0]) => ({ id, label, order }))
        .sort((a, b) => {
            if (a.order !== b.order) return a.order - b.order;
            return (a.label ?? "").localeCompare(b.label ?? "");
        });

    // Map selected IDs to actual option objects (for MUI internal value)
    const value = multiple
        ? formattedOptions.filter((opt) => selected.includes(opt.id))
        : formattedOptions.find((opt) => opt.id === selected) || null;

    const handleChange = (event, newValue) => {
        if (multiple) {
            setSelected(newValue.map((v) => v.id));
        } else {
            setSelected(newValue ? newValue.id : null);
        }
    };

    return (
        <Box flex={1}>
            <Typography fontWeight={"bold"} variant="subtitle1">
                {label}
                {required && <span style={{ color: "red" }}>{" *"}</span>}
            </Typography>
            <FormControl fullWidth>
                <Autocomplete
                    multiple={multiple}
                    disableClearable={!multiple}
                    disableCloseOnSelect={multiple}
                    autoComplete="off"
                    options={formattedOptions}
                    value={value}
                    onChange={handleChange}
                    getOptionLabel={(option) =>
                        option.label.length > 20
                            ? option.label.substring(0, 20) + "..."
                            : option.label
                    }
                    isOptionEqualToValue={(opt, val) => opt.id === val.id}
                    renderOption={(props, option, { selected }) => (
                        <li {...props} key={option.id}>
                            {multiple && (
                                <Checkbox
                                    checked={selected}
                                    style={{ marginRight: 8 }}
                                />
                            )}
                            {option.label}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Type to search..."
                            variant="outlined"
                            autoComplete="new-field"
                            error={error}
                        />
                    )}
                />
            </FormControl>
        </Box>
    );
};

export default DropdownSearchSelector;
